import { enumBrowsers } from "../constants";
import { Globals } from "../CoreApp/Globals";

export function SourceBrowser() {
  if (Globals._userBrowser == -1) {
    var agent = navigator.userAgent;
    var ua = agent,
      tem,
      M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
    if (/trident/i.test(M[1])) {
      tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
      Globals._browserStr = "IE " + (tem[1] || "");
    }
    if (M[1] === "Chrome") {
      tem = ua.match(/\b(OPR|Edge)\/(\d+)/);
      if (tem != null) Globals._browserStr = tem.slice(1).join(" ").replace("OPR", "Opera");
    }
    M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, "-?"];
    if ((tem = ua.match(/version\/(\d+)/i)) != null) {
      M.splice(1, 1, tem[1]);
    }

    if (Globals._browserStr === "") Globals._browserStr = M.join(" ");

    if (Globals._browserStr.indexOf("Firefox") != -1) Globals._userBrowser = enumBrowsers.FireFox;
    else if (Globals._browserStr.indexOf("Chrome") != -1)
      Globals._userBrowser = enumBrowsers.Chrome;
    else if (Globals._browserStr.indexOf("Safari") != -1)
      Globals._userBrowser = enumBrowsers.Safari;
    else Globals._userBrowser = enumBrowsers.Other;
  }

  return [Globals._userBrowser, Globals._browserStr];
}
